import { IconButton, SxProps, Theme } from '@mui/material';
import React from 'react';

export default function IconContainer({name, sx, children}: {
    name: string;
    sx?: SxProps<Theme>;
    children: React.ReactNode;
}) {
    return <IconButton sx={{ padding: 'inherit', cursor: 'inherit', ...sx }} disableRipple={true} disableFocusRipple={true} aria-label={name} role='img'>{children}</IconButton>
}